module.exports = __webpack_public_path__ + "static/Jan_Seuntjens_headshot_lores-b69ded097896b64688ffe245ede8d8fe.png";